export const ArrowLeft = () => (
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.14062 0.554688L8.42969 1.25781L2.125 4.01562L8.42969 6.76562L8.14062 7.46875L0.921875 4.3125V3.71094L8.14062 0.554688Z"
      fill="#666666"
    />
  </svg>
);

export default ArrowLeft;
